import * as React from 'react';
import { MenuConfig, ToolbarConfig } from '@tencent/workbench';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import ICON from '@tencent/docs-design-resources/icon/desktop/svg/viewswitch_light_24.svg';
import i18n from 'i18next';
import {
    ITransitionItem,
    coverTransition,
    cutTransition,
    emptyTransition,
    fadeTransition,
    flashTransition,
    flipTransition,
    galleryTransition,
    prismTransition,
    pullTransition,
    pushTransition,
    switchTransition,
    warpTransition,
} from '@framework/workbench/common/components/selectable-panel/transition-card/config';

export const config = {
    id: ActionType.TRANSITION_CHANGE_SIMPLE,
    icon: ICON,
    content: i18n.t('切页'),
};

export const menuConfig = {
    id: ActionType.TRANSITION_EFFECT_SIMPLE_MENU,
};

export const TOOLBAR_ITEMS: ToolbarConfig[] = [
    {
        name: config.id,
        icon: <img src={config.icon} alt={''}/>,
        text: '',
        tooltip: config.content,
        hasArrow: true,
    },
];

export const TransitionList: ITransitionItem[] = [
    emptyTransition,
    fadeTransition,
    pushTransition,
    switchTransition,
    cutTransition,
    pullTransition,
    coverTransition,
    warpTransition,
    flipTransition,
    galleryTransition,
    prismTransition,
    flashTransition,
];

export const MENU_CONFIGS: MenuConfig[] = [
    {
        name: config.id,
        content: config.content,
    }, {
        name: menuConfig.id,
        content: '',
    }, {
        name: ActionType.TRANSITION_SIMPLE_MENU_ITEM_CHANGE,
        content: i18n.t('更换切换动画') as string,
    }, {
        name: ActionType.TRANSITION_SIMPLE_MENU_ITEM_EFFECT,
        content: i18n.t('效果选项') as string,
        tooltip: i18n.t('简约工具栏暂不支持设置效果，请切换至经典工具栏后再设置'),
        preventDismiss: true,
    }, {
        name: ActionType.TRANSITION_SIMPLE_MENU_ITEM_DURATION,
        content: i18n.t('持续时间') as string,
        tooltip: i18n.t('简约工具栏暂不支持设置效果，请切换至经典工具栏后再设置'),
        preventDismiss: true,
    }, {
        name: ActionType.TRANSITION_SIMPLE_MENU_ITEM_APPLY_ALL,
        content: i18n.t('将以上设置应用到全部页面') as string,
    },
    ...TransitionList.map(transition => ({
        name: `${ActionType.TRANSITION_SIMPLE_MENU_ITEM_CHANGE}-${transition.type}`,
        content: transition.text,
        icon: <img src={transition.icon} alt={''}/>,
    })),
];

